import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMondayInfo, performMondayApiRequest, getGrantedFeatures } from '../services/monday-service';
import LoaderComponent from '../components/loader/loader-component';
import getUserDataQuery from '../queries/get-user-data';
import { BILLING_BRAND_REMOVE } from '../constants/features';
import { Tiers } from '../constants/tiers';
const MondayContext = createContext(null);
const EUC_REGION = 'euc1';

export const MondayProvider = ({ children }) => {
  const [mondayContext, setMondayContext] = useState(null);
  const [sessionToken, setSessionToken] = useState(null);
  const [userData, setUserData] = useState(null);
  const [grantedFeatures, setGrantedFeatures] = useState(null);

  useEffect(() => {
    let isSubscribed = true;
    const getMondayContext = async () => {
      const { data } = await getMondayInfo('context');
      if (isSubscribed) {
        setMondayContext(data);
      }
    };

    !mondayContext && getMondayContext();

    return () => (isSubscribed = false);
  }, [mondayContext]);

  useEffect(() => {
    let isSubscribed = true;
    const getMondaySession = async () => {
      const { data } = await getMondayInfo('sessionToken');
      if (isSubscribed) {
        setSessionToken(data);
      }
    };

    !sessionToken && getMondaySession();

    return () => (isSubscribed = false);
  }, [sessionToken]);

  useEffect(() => {
    let isSubscribed = true;
    const getUserData = async () => {
      const { me } = await performMondayApiRequest(getUserDataQuery());
      const {
        account: { id: accountId, tier },
        ...details
      } = me;

      const usedTier = tier || Tiers.ALL_TIERS.TRIAL;

      if (isSubscribed) {
        setUserData({ accountId, tier: usedTier, ...details });
      }
    };

    !userData && getUserData();

    return () => (isSubscribed = false);
  }, [userData]);

  useEffect(() => {
    let isSubscribed = true;
    const getGrantedFeaturesData = async () => {
      const data = await getGrantedFeatures([BILLING_BRAND_REMOVE]);
      if (isSubscribed) {
        setGrantedFeatures(data);
      }
    };

    !grantedFeatures && getGrantedFeaturesData();

    return () => (isSubscribed = false);
  }, [grantedFeatures]);

  if (mondayContext?.region === EUC_REGION)
    return (
      <div className="block-screen">
        <img src="./assets/constructions.png" alt="" />
        <span>Quotes & Invoices is not yet available in the EU region</span>
      </div>
    );

  if (!mondayContext || !sessionToken || !userData) return <LoaderComponent />;

  return (
    <MondayContext.Provider value={{ mondayContext, userData, sessionToken, grantedFeatures }}>
      {children}
    </MondayContext.Provider>
  );
};

export const useMondayContext = () => {
  return useContext(MondayContext);
};
